<template>
  <div
    class="main-header-wraper flex"
    :class="{
      [`main-header-wraper--${createRenderType}`]: true,
      'main-header-wraper-summon-visible':
        headSummonVisible && $$language() != 'cn',
    }"
  >
    <div
      class="logo"
    >
      MUREKA
    </div>
    <!-- <div class="main-header-nav-list">
      <li
        class="fn-inline"
        :class="{
          active: route.meta.title == 'create',
        }"
        @click="
          () => {
            goRouter('create');
          }
        "
      >
        {{ $$t("common.nav_create_music") }}
      </li>
      <li
        class="fn-inline"
        :class="{
          active: route.meta.title == 'store',
        }"
        @click="
          () => {
            goRouter('store');
          }
        "
      >
        {{ $$t("common.nav_store") }}
      </li>
      <li
        class="fn-inline"
        :class="{
          active: route.meta.title == 'library',
        }"
        @click="
          () => {
            goRouter('library');
          }
        "
      >
        {{ $$t("common.nav_library") }}
      </li>
    </div> -->
    <div class="flex1 width-0">
      <div
        v-if="createRenderType == 'mobile' && showVideoTipData.isShow"
        :class="[
          'flex-row-center',
          'video-result-tip',
          `video-result-tip-${showVideoTipData.type}`,
        ]"
        @click="goResult"
      >
        <div class="flex1">
          {{
            showVideoTipData.type == "success"
              ? "Your music video is ready. Click to view!"
              : "Your music video generation failed. Please try again"
          }}
        </div>
        <img
          v-if="showVideoTipData.type == 'success'"
          src="@/assets/img/activity/arrow-right.png"
          alt=""
        />
        <img v-else src="@/assets/img/activity/arrow-right-fail.png" alt="" />
      </div>
      <div
        v-if="!(createRenderType == 'mobile' && route?.name == 'home')"
        class="header-top flex pointer"
        @click="handleActivity"
      >
        <i
          :class="{
            'header-top-ico': true,
            'header-top-christmas-ico': isChristmas,
          }"
        >
        </i>
        <div class="header-top-bg" v-if="isChristmas">
          <img src="@/assets/img/christmas-bg.png" alt="" />
        </div>
        <div class="flex1 header-top-text width-0">
          <span :class="createRenderType == 'mobile' ? '' : 'olh'">
            {{
              createRenderType == "pc"
                ? activityConfig?.description_pc
                : activityConfig?.description_h5
            }}
          </span>
          <div
            v-show="createRenderType != 'mobile' && !isChristmas"
            class="header-top-btn"
          ></div>
        </div>
        <div class="header-top-close" @click.stop>
          <IconButton
            size="30px"
            icoSize="16px"
            backgroundColor="rgb(0, 0, 0, 0.1)"
            hoverBackgroundColor="rgb(0, 0, 0, 0.2)"
            @onClick="doCloseHeadSummon"
          >
            <img src="@/assets/img/close-ico.png" />
          </IconButton>
        </div>
      </div>
      <div class="flex-space-between flex1 content" v-if="!(isCreatePage && createRenderType == 'mobile')">
        <div class="title">
          <div class="olh">
             {{ showTitle ? $$t(showTitle) : "" }}
          </div>
          <!--v-if="$route.name != 'create' || createRenderType == 'mobile'" <ModeSwitch v-else></ModeSwitch> -->
        </div>
        <div class="flex-center fixed-right">
          <div v-if="globalConfig.appname !== chinaAppName " class="language-icon" @click="renderData.langSwitchDialogVisible = true">
            <img src="@/assets/img/login/icon-globe.svg" alt="">
          </div>
          <div class="invite" @click="handleInvite">
            <img src="@/assets/img/gift.png" alt="" />
          </div>
          <div v-if="userDataStore.isLogin" @click="goSubscribe">
            <div
              class="credit flex-row-center"
              v-if="userDataStore?.userInfo?.user?.is_vip"
            >
              <img src="@/assets/img/credit.png" alt="" />
              <span
                >{{ $$t("library.Credits") }}:{{
                  userDataStore?.credits || 0
                }}</span
              >
            </div>
            <div class="subcribe" v-else>{{ $$t("create.subscribe") }}</div>
          </div>
          <div v-else class="try" @click="showLogin">
            {{ $$t("mine.try_free_now") }}
          </div>
          <div class="avatar flex-center" v-if="userDataStore.isLogin">
            <div class="mobile">
              <img
                :src="
                  userDataStore?.userInfo?.user?.profile_image
                    ? getObjectStorageFullUrl(
                        userDataStore?.userInfo?.user?.profile_image
                      )
                    : defaultLogin
                "
                alt="header"
                @click="goRouter('profile')"
              />
            </div>
          </div>
        </div>
      </div>
      <CreateTabNav v-if="isCreatePage && createRenderType == 'mobile'"></CreateTabNav>
    </div>
  </div>
  <SwitchLanguageDialog
    v-if="renderData.langSwitchDialogVisible"
    v-model:visible="renderData.langSwitchDialogVisible"
  >
  </SwitchLanguageDialog>
</template>

<script setup>
import {
  ref,
  defineProps,
  defineEmits,
  reactive,
  watch,
  onMounted,
  onUnmounted,
  getCurrentInstance,
} from "vue";
import { useRouter, useRoute } from "vue-router";
import ModeSwitch from "@/page/create/modeSwitch.vue";
import CreateTabNav from "@/page/create/createTabNav.vue"
import useShopCartStore from "@/store/shopCartStore.js";
import useUserDataStore from "@/store/userDataStore";
import { funComponentList } from "@/components/functionComp/index";
import { getObjectStorageFullUrl } from "@/lib/objectStorage/objectStorage.js";
import Bubble from "@/components/bubble/bubble.vue";
import message from "@/components/functionCallComponent/message/message.js";
import { showActionDialog } from "@/components/functionCallComponent/action/action.js";
import { isDev, registPolling } from "@/utils/tools.js";
import layoutConfig, { initLayout } from "@/config/layoutConfig.js";
import ShowInviteDialog from "@/components/inviteDialog/inviteDialog.js";

import { storeToRefs } from "pinia";
import useCreateLayoutStore from "@/store/create/createLayoutStore.js";
import useCreatVideoResultDataStore from "@/store/createVideo/creatVideoResultDataStore";
import useHomeDataStore from "@/store/homeDataStore";
import defaultLogin from "@/assets/img/mobile/default_login.png";
import SwitchLanguageDialog from "@/mobile/mine/components/switchLanguageDialog.vue"
import globalConfig, { chinaAppName } from "@/config/config.js"

const createLayoutStore = useCreateLayoutStore();
const creatVideoResultDataStore = useCreatVideoResultDataStore();
const userDataStore = useUserDataStore();
const homeDataStore = useHomeDataStore();
const { createRenderType, headSummonVisible, activityConfig } =
  storeToRefs(createLayoutStore);
const { last_generate_video } = storeToRefs(creatVideoResultDataStore);
const { showVideoTipData } = storeToRefs(homeDataStore);
const globalProperties =
  getCurrentInstance()?.appContext.config.globalProperties;
const { $$t, $$language } = globalProperties?.$i18n ?? {};

const Router = useRouter();
const route = useRoute();

const props = defineProps({});
const emits = defineEmits([]);
const showTitle = ref("");
const shopCartStore = useShopCartStore();
const isChristmas = ref(false);

const renderData = reactive({
  langSwitchDialogVisible: false,
})
const stateData = {
  refreshTimer: null,
};


const isCreatePage = computed(
  () =>
    route.name == "create" ||
    route.name == "createIndex" ||
    route.name == "editor" ||
    route.name == "instrumental"
)
const goResult = () => {
  globalProperties.logClickEvent('activity_alert', {
    activity_name: 'christmas_lip'
  })
  homeDataStore.updateVideoShowTip({
    isShow: false,
    type: "",
  });
  Router.push({
    name: "createVideo",
    query: {
      form: "tip",
    },
  });
};

const goRouter = (name) => {
  Router.push({
    name: name,
    query: {
      origin: route.name,
    },
  });
};

const openUrl = (url) => {
  window.open(url, "_blank");
  globalProperties.logClickEvent("create_top_banner", {});
};

const doCloseHeadSummon = () => {
  createLayoutStore.setHeadSummonVisible(false);
  globalProperties.logClickEvent("create_top_banner_close", {});
};

const showLogin = () => {
  console.log("$$language()", $$language());
  // if (layoutConfig.renderType == "mobile") {
  //   Router.push({
  //     name: "mine",
  //   })
  // }
  userDataStore.checkLoginStatus({})
  // funComponentList.ThirdLogin({
  //   // rightType: "generate",
  //   handleOk: (str) => {
  //     console.log("点击成功" + str);
  //     console.log("userDataStore.isLogin", userDataStore.isLogin);
  //   },
  // });
};

const handleInvite = () => {
  if (userDataStore.isLogin) {
    ShowInviteDialog();
  } else {
    showLogin();
  }
  globalProperties.logClickEvent("Invite_for_free_credits", {});
};

watch(
  () => route.meta,
  (val) => {
    showTitle.value = val?.titlekey ?? "";
  },
  {
    immediate: true,
  }
);

watch(
  () => userDataStore.isLogin,
  (val) => {}
);

watch(
  () => last_generate_video.value,
  () => {
    const val = last_generate_video.value?.video?.state;
    if (val == 3 || val == 4) {
      globalProperties.logViewEvent("activity_alert", {
        activity_name: "christmas_lip",
      });
      homeDataStore.updateVideoShowTip({
        isShow: true,
        type: val == 3 ? "success" : val == 4 ? "fail" : "",
      });
    }
  }
);

const goSubscribe = () => {
  Router.push({
    name: "subscribe",
  });
};

const handleActivity = () => {
  if (isChristmas.value) {
    const queryString = userDataStore.activityConfig?.url.split("?")[1];
    const query = queryString ? queryString.split("&").reduce((acc, param) => {
      const [key, value] = param.split("=");
      if (key && value) {
        acc[key] = decodeURIComponent(value);
      }
      return acc;
    }, {}) : {}
    Router.push({
      name: "createVideo",
      query
    });
  } else {
    openUrl(userDataStore.activityConfig?.url);
  }
};

onMounted(() => {
  stateData.registPollingCall = registPolling(() => {
    userDataStore.getBanerConfig().then(() => {
      if (userDataStore.activityConfig) {
        createLayoutStore.initActivityConfig(userDataStore.activityConfig);
      }
    });
  }, 60 * 1000 * 30);
});

watch(
  () => userDataStore.appLanguage,
  (newVal) => {
    userDataStore.getBanerConfig().then(() => {
      if (userDataStore.activityConfig) {
        createLayoutStore.initActivityConfig(userDataStore.activityConfig);
      }
    });
  }
);

watch(
  () => userDataStore.activityConfig,
  (val) => {
    if (userDataStore.activityConfig) {
      createLayoutStore.initActivityConfig(userDataStore.activityConfig);
    }
  }
);

onUnmounted(() => {
  stateData.registPollingCall()?.();
});
</script>
<style lang="scss">
.main-header-wraper {
  width: 100%;
  max-width: 100%;
  .logo {
    width: 126px;
    height: 40px;
    font-size: 0px;
    font-weight: 900;
    line-height: 40px;
    color: #fff;
    margin: 16px 54px 8px 20px;
    background: url("@/assets/img/head-logo.png");
    background-size: 100% 100%;
    &.cn {
      background: url("@/assets/img/head-logo-cn.png");
      background-size: 100% 100%;
    }
  }
  .el-dropdown-link {
    display: block;
    width: 32px;
    height: 32px;
    &:hover {
      opacity: 0.8;
    }
  }
  .content {
    margin: 16px 16px 0 0;
    padding: 0 16px 0px 20px;
    border-radius: 16px 16px 0 0;
    border-bottom: 1px solid rgba(255, 255, 255, 0.1);
    .title {
      font-family: HarmonyOS Sans SC;
      font-size: 24px;
      font-weight: 600;
      line-height: 60px;
      color: #fff;
      text-transform: capitalize;
      flex: 0 1 auto;
    }
  }
  .language-icon{
    display: flex;
    padding: 6px;
    align-items: center;
    border-radius: 16px;
    background: rgba(255, 255, 255, 0.12);
    margin-right: 8px;
  }
  .invite {
    padding: 6px 14px;
    margin-right: 8px;
    border-radius: 50px;
    background: rgba(255, 255, 255, 0.12);
    img {
      display: block;
      width: 16px;
      height: 16px;
    }
  }
  .try {
    padding: 5px 14px;
    font-size: 12px;
    font-weight: 900;
    line-height: 18px;
    background: linear-gradient(106deg, #1a3c8d 5%, #695bc5 47%, #3a1b6f 100%);
    border-radius: 50px;
    color: #fff;
  }
  .subcribe {
    padding: 4px 12px;
    background: linear-gradient(92deg, #4fdeff -39%, #d9f8ff 52%, #e675ff 132%);
    color: #000;
    font-size: 12px;
    line-height: 20px;
    border-radius: 20px;
  }
  .credit {
    padding: 4px 12px;
    border-radius: 20px;
    background: rgba(148, 173, 255, 0.2);
    img {
      width: 16px;
      height: 16px;
      display: block;
      margin-right: 4px;
    }
    span {
      font-size: 12px;
      line-height: 20px;
      color: #fff;
    }
  }
  .avatar {
    border-radius: 50%;
    margin-left: 8px;
    // height: 40px;
    display: none;
    align-items: center;
    &:hover {
      opacity: 0.8;
    }
    img {
      border-radius: 50%;
      width: 32px;
      height: 32px;
    }
    .mobile {
      display: none;
    }
  }

  .flex-space-between {
    height: 62px;
    display: none;
  }
  .video-result-tip {
    padding: 10px 10px 10px 12px;
    border-radius: 11px;
    margin-bottom: 14px;
    font-size: 14px;
    line-height: 16px;
    img {
      width: 18px;
      height: 18px;
    }
    &-success {
      background: #72ffec;
      color: #000;
    }
    &-fail {
      background: #fff3ec;
      color: #f40021;
    }
  }
  .header-top {
    position: relative;
    margin: 12px 16px 12px 0;
    border-radius: 30px;
    background: linear-gradient(92deg, #4fdeff 0%, #e675ff 100%);
    align-items: center;
    padding: 6px 6px 6px 12px;
    display: none;
    overflow: hidden;
    &:hover {
      opacity: 0.9;
    }
    .header-top-ico {
      width: 28px;
      height: 28px;
      background: url(@/assets/img/summon-ico.png);
      background-size: 100% 100%;
    }
    .header-top-christmas-ico {
      background: url(@/assets/img/christmas-gift.png);
      background-size: 100% 100%;
    }
    .header-top-text {
      position: relative;
      font-family: HarmonyOS Sans SC;
      font-size: 14px;
      font-weight: normal;
      line-height: 18px;
      color: #000000;
      margin: 0 8px;
      display: flex;
      align-items: center;
      span {
        flex: 0 1 auto;
      }
    }
    .header-top-btn {
      margin: 0 0 0 12px;
      width: 38px;
      min-width: 38px;
      height: 20px;
      background: url(@/assets/img/head-top-right-btn.png);
      background-size: 100% 100%;
    }
    .header-top-bg {
      position: absolute;
      right: 0;
      top: 0;
      pointer-events: none;
      img {
        width: 474px;
      }
    }
  }
  &.main-header-wraper-summon-visible {
    height: unset;
    .header-top {
      display: flex;
    }
    .flex-space-between {
      margin: 8px 16px 0 0;
    }
  }

  &.main-header-wraper--mobile {
    display: flex;
    align-items: center;
    padding: 16px 16px 0 16px;
    margin-bottom: 16px;
    .header-top-text {
      font-size: 12px;
      font-weight: normal;
      line-height: 16px;
    }
    &.main-header-wraper-summon-visible {
      padding: 10px 16px 0 16px;
      .header-top {
        display: flex;
        margin: 2px 0 2px 0;
      }
      .flex-space-between {
        margin: 8px 16px 0 0;
        display: flex;
      }
    }
    margin-bottom: 12px;
    .logo {
      display: none;
    }
    .content {
      margin: 0;
    }
    .title {
      line-height: 32px;
      width: 0;
      flex: 1;
      margin-right: 16px;
    }
    .flex-space-between {
      width: 100%;
      height: 32px;
      padding: 0;
      border-bottom: none;
      display: flex;
    }
  }

  @media (max-width: 768px) {
    .avatar {
      display: flex;
      img {
        display: block;
        width: 26px;
        height: 26px;
      }
      .mobile {
        display: flex;
        align-items: center;
        justify-content: center;
      }
      .pc {
        display: none;
      }
    }
    .header-top {
      .header-top-bg {
        position: absolute;
        right: -4px;
        top: unset;
        bottom: -4px;
        img {
          width: 274px;
        }
      }
    }
  }
}
.header-drop {
  background: unset !important;
  border: none !important;
  .el-popper__arrow {
    display: none;
  }
  .el-scrollbar {
    background: unset !important;
  }
  .el-dropdown-menu {
    padding: 0;
    // background: rgba(255, 255, 255, 0.2);
    // backdrop-filter: blur(15px);
    background-color: #3e3450;
    border: none;
    font-weight: bold;
    border-radius: 8px;
    overflow: hidden;
    .el-dropdown-menu__item {
      color: #fff;
      padding: 8px 20px;
      font-weight: 400;
    }
  }
  .el-dropdown-menu__item:not(.is-disabled):focus {
    background: rgba(255, 255, 255, 0.1);
    color: #fff;
  }
  .el-dropdown-menu__item:not(.is-disabled):hover {
    background: rgba(255, 255, 255, 0.1);
    color: #fff;
  }
}
</style>
